module.exports = __webpack_public_path__ + "img/store-solid.bb44210b.svg";